export default __webpack_public_path__ + "static/media/3-JOUEUR.cfe1bc16.pdf";